<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Categorie',
      link: '/categorie'
    }, {
      label: form.uuid ? 'Modifica Categoria' : 'Aggiungi nuova Categoria'
    }]"
  />
  <form autocomplete="off">
    <InputText
      v-model="form.code"
      :error-fields="errorFields"
      name="code"
      :submitted="submitted"
    >
      Codice
    </InputText>

    <InputTextarea
      v-model="form.multilangName"
      :error-fields="errorFields"
      help="{ &quot;it&quot; : &quot;Nome in italiano&quot;, &quot;en&quot; : &quot;Name in english&quot; }"
      name="multilangName"
      :submitted="submitted"
    >
      Nome localizzato
    </InputTextarea>

    <InputInteger
      v-model="form.maxQuantityPercentage"
      :error-fields="errorFields"
      name="maxQuantityPercentage"
      :submitted="submitted"
    >
      Percentuale Quantità massima
    </InputInteger>

    <InputInteger
      v-model="form.maxGroupQuantityPercentage"
      :error-fields="errorFields"
      name="maxGroupQuantityPercentage"
      :submitted="submitted"
    >
      Percentuale Quantità massima per Gruppi
    </InputInteger>

    <InputInteger
      v-model="form.tolerance"
      :error-fields="errorFields"
      name="maxQuantityPercentage"
      :submitted="submitted"
    >
      Percentuale Tolleranza
    </InputInteger>

    <InputInteger
      v-model="form.groupTolerance"
      :error-fields="errorFields"
      name="maxGroupQuantityPercentage"
      :submitted="submitted"
    >
      Percentuale Tolleranza per Gruppi
    </InputInteger>

    <SubmitButtons
      :create-and-back="createAndBack"
      :create-and-stay="createAndStay"
      :mode="form.uuid ? 'update' : 'create'"
      :pending="pending"
      :update-and-back="updateAndBack"
      :update-and-stay="updateAndStay"
    />
  </form>
</template>

<script setup>
import { reactive } from "vue";

import InputInteger from "@/components/form/InputInteger.vue";
import InputText from "@/components/form/InputText.vue";
import InputTextarea from "@/components/form/InputTextarea.vue";
import SubmitButtons from "@/components/form/SubmitButtons.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from "@/composables/axios";
import useForm from "@/composables/form";
import Validation from "@/services/validation";

const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  },
});

const axios = useAxios();

let form = reactive({
  code: "",
  maxGroupPercentage: null,
  maxGroupQuantityPercentage: null,
  tolerance: null,
  groupTolerance: null
});

if (props.id) {
  const resp = await axios.get("/category/" + props.id);
  form = reactive(resp.data);
}

const rules = {
  code: {
    type: "string",
    max: 12,
    required: true,
  },
  multilangName: {
    type: "string",
    required: true,
    validator: Validation.isJson
  },
  maxQuantityPercentage: {
    type: "integer",
    required: true,
    min: 0,
    max: 100
  },
  maxGroupQuantityPercentage: {
    type: "integer",
    required: true,
    min: 0,
    max: 100
  },
  tolerance: {
    type: "integer",
    required: true,
    min: 0,
    max: 100
  },
  groupTolerance: {
    type: "integer",
    required: true,
    min: 0,
    max: 100
  }
};

const { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay } = useForm(form, 'category', rules, {
  create: 'Categoria creata con successo',
  update: 'Categoria modificata con successo'
}, '/categorie', () => {
  form.code = ''
  form.multilangName = '';
  form.maxGroupPercentage = null;
  form.maxGroupQuantityPercentage = null
  form.tolerance = null;
  form.groupTolerance = null
})

</script>
